import axios from 'axios';

const runtimeConfig =
  typeof window !== 'undefined' && window.__APP_CONFIG__
    ? window.__APP_CONFIG__
    : {};

function normalizeApiBaseUrl(baseUrl) {
  const trimmed = String(baseUrl || '').replace(/\/+$/, '');
  if (!trimmed) {
    return '';
  }

  if (typeof window === 'undefined') {
    return trimmed;
  }

  try {
    const parsed = new URL(trimmed);
    const currentHost = window.location && window.location.hostname ? window.location.hostname.toLowerCase() : '';

    if (['localhost', '127.0.0.1', '::1'].includes(parsed.hostname.toLowerCase()) && currentHost && !['localhost', '127.0.0.1', '::1'].includes(currentHost)) {
      return window.location.origin + parsed.pathname.replace(/\/+$/, '');
    }
  } catch (error) {
    return trimmed;
  }

  return trimmed;
}

const API_BASE_URL = normalizeApiBaseUrl(runtimeConfig.API_BASE_URL || '');

if (!API_BASE_URL) {
  throw new Error('API_BASE_URL is not configured in public/runtime-config.js');
}

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = false;

axios.interceptors.request.use((config) => {
  config.baseURL = API_BASE_URL;

  return config;
});

const httpClient = axios.create({
  baseURL: API_BASE_URL
});

httpClient.interceptors.request.use((config) => {
  config.baseURL = API_BASE_URL;

  return config;
});

export default httpClient;
